import Enum from '/@/modules/core/app/helpers/Enum';
import Lang from '/@/modules/core/app/services/Lang';

export class PredefinedTimeEntryDuration extends Enum {
  value!: number;
  label!: string;

  static ONE: PredefinedTimeEntryDuration = {
    value: 1,
    get label() {
      return Lang.t('1m');
    }
  };

  static THREE: PredefinedTimeEntryDuration = {
    value: 3,
    get label() {
      return Lang.t('3m');
    }
  };

  static FIVE: PredefinedTimeEntryDuration = {
    value: 5,
    get label() {
      return Lang.t('5m');
    }
  };

  static TEN: PredefinedTimeEntryDuration = {
    value: 10,
    get label() {
      return Lang.t('10m');
    }
  };

  static FIFTEEN: PredefinedTimeEntryDuration = {
    value: 15,
    get label() {
      return Lang.t('15m');
    }
  };

  static TWENTY: PredefinedTimeEntryDuration = {
    value: 20,
    get label() {
      return Lang.t('20m');
    }
  };

  static TWENTY_FIVE: PredefinedTimeEntryDuration = {
    value: 25,
    get label() {
      return Lang.t('25m');
    }
  };

  static THIRTY: PredefinedTimeEntryDuration = {
    value: 30,
    get label() {
      return Lang.t('30m');
    }
  };

  static THIRTY_FIVE: PredefinedTimeEntryDuration = {
    value: 35,
    get label() {
      return Lang.t('35m');
    }
  };

  static FORTY: PredefinedTimeEntryDuration = {
    value: 40,
    get label() {
      return Lang.t('40m');
    }
  };

  static FORTY_FIVE: PredefinedTimeEntryDuration = {
    value: 45,
    get label() {
      return Lang.t('45m');
    }
  };

  static FIFTY: PredefinedTimeEntryDuration = {
    value: 50,
    get label() {
      return Lang.t('50m');
    }
  };

  static FIFTY_FIVE: PredefinedTimeEntryDuration = {
    value: 55,
    get label() {
      return Lang.t('55m');
    }
  };

  static SIXTY: PredefinedTimeEntryDuration = {
    value: 60,
    get label() {
      return Lang.t('60m');
    }
  };

  static NINETY: PredefinedTimeEntryDuration = {
    value: 90,
    get label() {
      return Lang.t('90m');
    }
  };

  static ONE_TWENTY: PredefinedTimeEntryDuration = {
    value: 120,
    get label() {
      return Lang.t('2h');
    }
  };

  static ONE_EIGHTY: PredefinedTimeEntryDuration = {
    value: 180,
    get label() {
      return Lang.t('3h');
    }
  };

  static TWO_FORTY: PredefinedTimeEntryDuration = {
    value: 240,
    get label() {
      return Lang.t('4h');
    }
  };

  static THREE_HUNDRED: PredefinedTimeEntryDuration = {
    value: 300,
    get label() {
      return Lang.t('5h');
    }
  };

  static THREE_SIXTY: PredefinedTimeEntryDuration = {
    value: 360,
    get label() {
      return Lang.t('6h');
    }
  };

  static FOUR_TWENTY: PredefinedTimeEntryDuration = {
    value: 420,
    get label() {
      return Lang.t('7h');
    }
  };

  static FOUR_EIGHTY: PredefinedTimeEntryDuration = {
    value: 480,
    get label() {
      return Lang.t('8h');
    }
  };
}
